import { useState } from "react";
import { Box, Typography, useTheme, TextField, Button, Grid, Alert, Paper, Card, CardContent } from "@mui/material";
import { tokens } from "../../theme";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import Header from "../../components/Header";

const RegisterDataset = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [formData, setFormData] = useState({
    name: "",
    server: "",
    path: "",
    description: "",
    authorFirstName: "",
    authorLastName: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submitted, setSubmitted] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    setIsSubmitted(true);
    setSubmitted({
      id: "dfn",
      server: "Azure",
      author: "dd.dun",
      path: "zdfnl",
      created: "6/1/2025, 9:38:31 AM",
    });
  };

  const handleClearForm = () => {
    setFormData({
      name: "",
      server: "",
      path: "",
      description: "",
      authorFirstName: "",
      authorLastName: "",
    });
  };

  const sectionLabel = {
    color: colors.grey[500],
    fontSize: "0.6875rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    mb: 1.25,
  };

  return (
    <Box sx={{ p: 3, maxWidth: 1440, mx: "auto" }}>
      <Header
        icon={<AddBoxOutlinedIcon />}
        title="Register Dataset"
        subtitle="Add a new dataset definition to the federation registry."
      />

      {isSubmitted && (
        <Alert
          icon={<CheckCircleOutlineIcon fontSize="inherit" />}
          severity="success"
          sx={{ mb: 2 }}
        >
          Dataset submitted successfully.
        </Alert>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent sx={{ p: 2.5 }}>
              <Typography sx={sectionLabel}>Dataset Details</Typography>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField fullWidth required size="small" label="Dataset name" name="name" value={formData.name} onChange={handleChange} />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField fullWidth required size="small" label="Server" name="server" value={formData.server} onChange={handleChange} />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField fullWidth required size="small" label="Path" name="path" value={formData.path} onChange={handleChange} />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField fullWidth required size="small" multiline rows={3} label="Description" name="description" value={formData.description} onChange={handleChange} />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField fullWidth required size="small" label="Author first name" name="authorFirstName" value={formData.authorFirstName} onChange={handleChange} />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField fullWidth required size="small" label="Author last name" name="authorLastName" value={formData.authorLastName} onChange={handleChange} />
                  </Grid>
                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", gap: 1.5, mt: 0.5 }}>
                      <Button type="submit" variant="contained" color="primary" size="small">
                        Submit
                      </Button>
                      <Button variant="outlined" color="primary" size="small" onClick={handleClearForm}>
                        Clear form
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          {submitted ? (
            <Card>
              <CardContent sx={{ p: 2.5 }}>
                <Typography sx={sectionLabel}>Submitted</Typography>
                <Typography sx={{ color: 'var(--fx-text-primary)', fontWeight: 700, fontSize: "1rem", mb: 1.5 }}>
                  {submitted.id}
                </Typography>
                {[
                  ["Server", submitted.server],
                  ["Author", submitted.author],
                  ["Path", submitted.path],
                  ["Created", submitted.created],
                ].map(([k, v]) => (
                  <Box key={k} sx={{ display: "flex", justifyContent: "space-between", py: 0.5, borderBottom: `1px solid ${theme.palette.divider}` }}>
                    <Typography sx={{ color: colors.grey[500], fontSize: "0.75rem" }}>{k}</Typography>
                    <Typography sx={{ color: 'var(--fx-text-primary)', fontSize: "0.8125rem", fontWeight: 500 }}>{v}</Typography>
                  </Box>
                ))}
              </CardContent>
            </Card>
          ) : (
            <Paper variant="outlined" sx={{ p: 2.5, borderStyle: "dashed", borderColor: theme.palette.divider, textAlign: "center" }}>
              <Typography sx={{ color: colors.grey[500], fontSize: "0.8125rem" }}>
                Submitted datasets will appear here.
              </Typography>
            </Paper>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default RegisterDataset;
